/*
 * @Author: your name
 * @Date: 2021-02-17 19:45:15
 * @LastEditTime: 2022-11-08 16:39:33
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/store.js
 */
import store from '@/store'

function isEqualModifications(modification1, modification2) {
  const res = []
  modification1.forEach((item, index) => {
    item.options.forEach((each, i) => {
      const res1 = modification2[index].options[i].checked
      const res2 = each.checked
      res.push(res1 === res2)
      if (each.detail?.modifications) res.push(isEqualModifications(each.detail.modifications, modification2[index].options[i].detail.modifications))
    })
  })
  return res.every(item => item === true)
}

function isEqualMutipleSize(mutipleSize1, mutipleSize2) {
  if (!mutipleSize1 && !mutipleSize1) return true
  return (mutipleSize1.price === mutipleSize2.price) && (mutipleSize1.shortName === mutipleSize2.shortName)
}
/**
 * @returns
 * -2 => A product with recommended products. It should be listed as a product separately
 * -1 => This product is not found
 * others => Found this product
 */
/**
 * @returns
 * -2 => 有推荐商品的一个 product。应该单独列为一个 product
 * -1 => 没有找到这个 product
 * others => 找到了这个 product
 */

export function findSameObj(productList, product, type = 'normal') {
  const newProductId = product.id
  const newProductModifications = product.modifications
  const newProductSelectSize = product.selectSize
  const newProductUpgradeFromProductId = product.upgradeFromProductId

  if ((product.recommendFromProductId || product.aiRecommendFromProductId) && type === 'normal') {
    // If there is a fromProductId (manual or AI), create a new product in the productList
    // 如果有 fromProductId（手动或 AI 推荐），那就建立一个新的 product 到 productList 里
    return -2
  } else {
    // If there is no fromProductId, there is no recommended source
    // 如果没有 fromProductId，就是没有推荐来源
    return productList.findIndex(
      item => ((item.id === newProductId) && (newProductUpgradeFromProductId === item.upgradeFromProductId && isEqualModifications(item.modifications, newProductModifications)) && isEqualMutipleSize(item.selectSize, newProductSelectSize))
    )
  }
}

/**
 * Get the detailed data of the station according to the station ID of the commodity
 * @param id {String} Station ID of the commodity
 * @returns {Object} Detailed data of station
 */
/**
 * 根据商品的 station id, 获取 station 的详细数据
 * @param id {String} 商品的 station id
 * @returns {Object} station 的详细数据
 */
function _setStation(id) {
  const stationSettings = store.state.venueHome?.stationSettings ?? {}
  // The station switch set by the restaurant is ON, the station list has data, and the parameters have values to search for detailed data
  // 餐厅设置的 station 开关为开时，station 列表有数据，并且传参有值，就进行查找详细数据
  if (stationSettings?.enableStation && stationSettings?.stationList?.length && id) {
    return stationSettings.stationList.find(item => item.id === id) ?? null
  } else {
    return null
  }
}

/**
 * 购物车一行的金额 = 单价（含付费加料 / 规格价）× 数量。
 * 推荐品加购时 `price` 是不含加料的基础价，含加料的在 `realProductPrice`（product-detail `_getRealProductPrice`）；
 * 主菜的 `price` 本身已含加料、没有 `realProductPrice`。购物车小计（getters.total / subGroupCartVenueTotal）按这一个口径算，
 * 也就是后端 OrderItemForm 重算的 `rawCost × no`；算式与热修前两处内联写法逐字相同。
 * 验券清单**不用**它：验券照热修前发 getters.itemList（`_setProduct` 的 `price × num`），券的一致性转 Q2 后端统一算价
 * （Option A 收口 / Codex 第 5 轮，owner 2026-09-29）。
 * @param {{ price: number|string, realProductPrice?: number|string, num: number }} product 购物车里的原始商品
 * @returns {number}
 */
export function cartLineAmount(product) {
  return product.realProductPrice ? product.realProductPrice * product.num : product.price * product.num
}

export function _setProduct(product) {
  const addList = []
  const removeList = []
  const modifications = product?.modifications ?? []
  modifications.forEach(val => {
    const add = {}
    const remove = {}
    if (val.isCombo) return
    if (!val.removeType) {
      add.type = val.type
      add.name = val.name
      if (val.languages) add.languages = val.languages
      add.items = []
      val.options.forEach((v, i, a) => {
        if (v.checked) {
          const item = {
            name: v.name,
            adjustAmount: v.adjustPrice,
            no: v.number || 1
          }
          if (v.languages) item.languages = v.languages
          add.items.push(item)
        }
      })
    } else {
      remove.type = val.type
      remove.name = val.name
      if (val.languages) remove.languages = val.languages
      remove.items = []
      val.options.forEach((v, i, a) => {
        if (v.checked) {
          const item = {
            name: v.name,
            adjustAmount: v.adjustPrice,
            no: v.number || 1
          }
          if (v.languages) item.languages = v.languages
          remove.items.push(item)
        }
      })
    }
    const isEmptyAdd = add.name && add.type && add.items.length
    const isEmptyRemove = remove.name && remove.type && remove.items.length
    if (isEmptyAdd) {
      addList.push(add)
    }
    if (isEmptyRemove) {
      removeList.push(remove)
    }
  })
  if (!product.selectSize) {
    product.selectSize = {
      default: null,
      name: null,
      price: null,
      shortName: null
    }
  }
  const {
    index,
    ...selectSize
  } = product.selectSize
  const result = {
    id: null,
    name: product.name,
    no: product.num,
    isJardiniere: product.isJardiniere, // Whether the product in the package is a side dish   // 套餐商品中，该商品是否为配菜
    isPlus: product.isPlus, // Price of side dishes   // 配菜的价格
    amount: (parseFloat(product.price) * product.num),
    comment: 'comment',
    rowCost: product.price,
    addList,
    removeList,
    productGroup: product.productGroupId,
    menu: 'menu',
    type: product.type,
    status: product.status,
    venueProductId: product.id,
    isAddItem: product.isAddItem,
    recommendFromProductId: product.recommendFromProductId,
    aiRecommendFromProductId: product.aiRecommendFromProductId || '',
    aiRecommendScene: product.aiRecommendScene || '',
    aiRecommendAttribution: product.aiRecommendAttribution || null,
    // A/B test framework: widget-level attribution for manual recommendations.
    // Lives parallel to aiRecommendAttribution so manual & AI both carry attribution.
    // A/B 测试框架：人工推荐的 widget 归因，和 aiRecommendAttribution 并列存在，
    // 让人工推荐和 AI 推荐都能带上归因信息。
    recAttribution: product.recAttribution || null,
    shortName: product.shortName,
    productGroupCourse: product.productGroupCourse,
    selectSize,
    realProductPrice: product.realProductPrice,
    comboProducts: product.comboProducts,
    upgradeFromProductId: product.upgradeFromProductId,
    stockSettings: product?.stockSettings ?? {},
    station: _setStation(product.station),
    tags: product?.tags ?? [],
    containsTags: product?.containsTags ?? [],
    // Seafood country-of-origin — pure passthrough (backend gates whether it
    // is present; null = not set / non-AU / old behavior).
    // 海鲜产地 — 纯透传（是否下发由后端门控;null = 未设/非澳洲/老逻辑）。
    seafoodOrigin: product?.seafoodOrigin ?? null
  }
  // Include languages for multi-language support on order detail pages
  // 包含语言信息以支持订单详情页面的多语言切换
  if (product.languages) result.languages = product.languages
  return result
}
